import React from 'react';
import { Outlet } from 'react-router-dom';
import '../FishFinderBuilder.css';
import TopNavBar from './TopNavBar';

const SharedLayout = () => {
  return (
    <div className="shared-layout" style={{ 
      backgroundColor: '#000000', 
      minHeight: '100vh', 
      color: '#ffffff',
      padding: 0,
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden'
    }}>
      <TopNavBar />
      <main className="shared-main" style={{ 
        backgroundColor: '#000000', 
        padding: 0, 
        margin: 0, 
        maxWidth: '100%',
        width: '100%',
        color: '#ffffff',
        overflow: 'hidden'
      }}>
        <Outlet />
      </main>
    </div>
  );
};

export default SharedLayout; 